export default __webpack_public_path__ + "static/footer-bg-ff6536c5a603a1c7f3d9bc07c9d64e0a.png";